import React from 'react';

import ProductCardContainer from 'components/Common/Card/ProductCard/ProductCardContainer/ProductCardContainer';
import ProductCardImage from 'components/Common/Card/ProductCard/ProductCardImage/ProductCardImage';
import ProductCardLabel from 'components/Common/Card/ProductCard/ProductCardLabel/ProductCardLabel';
import { useScrollIntoView } from 'hooks/useScrollIntoView';
import { getUri } from 'services/generic';
import { getName, getVisuelFace } from 'services/product/attributes';
import { ProductType } from 'types/ProductListing/ProductListing';

import styles from './GroupedProduct.module.scss';

type PropsType = {
  product: ProductType;
  onClick: () => void;
  scrollInto?: boolean;
};

export default function GroupedProduct({
  product: { attributes, url },
  onClick,
  scrollInto,
}: PropsType): JSX.Element {
  const scrollRef = useScrollIntoView();

  return (
    <ProductCardContainer
      linkTo={getUri(url)}
      onClick={onClick}
      ref={scrollInto ? scrollRef : undefined}
    >
      <ProductCardImage
        images={[{ alt: getName(attributes), src: getVisuelFace(attributes) }]}
        classes={{ container: styles.imageContainer }}
      />
      <ProductCardLabel
        label={getName(attributes)}
        className={styles.labelContainer}
        classes={{ label: styles.label }}
      />
    </ProductCardContainer>
  );
}
